const checkIsNewDate = (array, item, index) => {
  const prevMessage = index > 0 ? array[index - 1] : null;
  const date = new Date(item.timestamp);
  const prevDate = prevMessage ? new Date(prevMessage.timestamp) : date;

  if (
    index === 0 ||
    date.getFullYear() !== prevDate.getFullYear() ||
    date.getMonth() !== prevDate.getMonth() ||
    date.getDate() !== prevDate.getDate()
  ) {
    return true;
  }

  return false;
}

export default checkIsNewDate;